import { Picture } from './Picture';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ImageSource } from 'types/imageSource';

const LogoContainer = styled.div`
  position: absolute;
  top: -75px;
  left: 50%;
  margin-left: -75px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  background-color: #f8f8f8;
  border: 6px solid white;
  overflow: hidden;
`;

const Logo = styled(Picture)`
  max-height: 150px;
  max-width: 150px;
  display: block;
`;

export const RoundLogo: FC<{ source: ImageSource }> = ({ source }) => {
  return (
    <LogoContainer>
      <Logo source={source} />
    </LogoContainer>
  );
};
